<template>
    <div :class="{'mt-15': !noMargin, 'mt-n3': noMargin && $vuetify.display.mdAndUp}">
        <product-detail-tabs
            v-if="$vuetify.display.lgAndUp"
            :tab="tab"
            :product="product"
            :tabs="tabs"
            :also-like="alsoLike"
            @update:model-value="tab = $event"
        >
        </product-detail-tabs>
        <product-detail-mobile-tabs
            v-else
            :tab="tab"
            :tabs="tabs"
            @update:model-value="tab = $event"
        >
        </product-detail-mobile-tabs>
    </div>
</template>

<script setup>
import {computed, defineAsyncComponent, ref} from "vue";

const props = defineProps({
    product: Object,
    noMargin: Boolean,
    alsoLike: Array
})
import ProductDescription from "./ProductDescription.vue";
import {usePage} from "@inertiajs/vue3";
import ToDownload from "./ToDownload.vue";
import ProductDetailTabs from "./ProductDetailTabs.vue";
import ProductDetailMobileTabs from "./ProductDetailMobileTabs.vue";
import {trans} from "laravel-vue-i18n";
import Videos from "./Videos.vue";

const tab = ref(null);
const tabs = computed(() => {
    const _tabs = [];
    if(props.product.description || props.product.product_parameters.length){
        _tabs.push({
            name: trans('eshop::product-details.description_parameters'),
            component: ProductDescription,
            props: {
                product: props.product
            }
        })
    }
    /*_tabs.push({
        name: trans('eshop::product-details.reviews'),
        component: defineAsyncComponent(() => import('./Reviews.vue')),
        props: {
            user: usePage().props.customer,
            count: props.product.product_reviews_count,
            id_product: props.product.id,
        }
    })*/
    if(props.product.files?.length) {
        _tabs.push({
            name: trans('eshop::product-details.downloads'),
            component: ToDownload,
            props: {
                files: props.product.files
            }
        })
    }
    if(props.product.videos?.length) {
        _tabs.push({
            name: trans('eshop::product-details.videos'),
            component: Videos,
            props: {
                videos: props.product.videos
            }
        })
    }
    if (props.product.manufacturer) {
        _tabs.push({
            name: trans('eshop::product-details.about_manufacturer'),
            title: trans('eshop::product-details.about_manufacturer') + ' ' +props.product.manufacturer.name,
            component: defineAsyncComponent(() => import('./AboutManufacturer.vue')),
            props: {
                manufacturer: props.product.manufacturer,
            }
        })
    }
    let cssClass = '';
    if(props.product.is_universal === 'Y') {
        cssClass = 'bg-purple-lighten-6'
    } else if('is_compatible' in props.product) {
        cssClass = props.product.is_compatible && usePage().props.modelSearch?.model?.full_name? 'bg-orange-lighten-4' : 'bg-red-lighten-5';
    } else {
        if(usePage().props.modelSearch?.model?.full_name) {
            cssClass = 'bg-orange-lighten-4';
        } else {
            cssClass = 'bg-blue-lighten-4';
        }
    }
    _tabs.push({
        name: trans('eshop::product-details.compatibility'),
        component: defineAsyncComponent(() => import('./CompatibilityTab.vue')),
        class: cssClass,
        noTopMargin: true,
        props: {
            product: props.product,
        }
    });
    return _tabs;
})
</script>

<style scoped lang="scss">
@use 'vuetify/lib/styles/settings/variables' as *;

:deep(.c-transparent-tabs) {
    --v-tabs-height: 72px;
    box-shadow: 0 0 80px 0 rgba(0, 0, 0, 0.08);

    .v-slide-group__content {
        gap: $spacer * 5;
    }
}
</style>
